import {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../../components/button';
import CardInputGroup from '../../../../../../components/mazraeKit/CardInputGroup';
import SpinnerLoading from '../../../../../../components/SpinnerLoading';
import useGetMyStoreInputGroups from '../../../../../../services/hookService/getMyStoreInputGroups/useGetMyStoreInputGroups';
import {IGetStoreInputGroupsParams} from '../../../../../../services/hookService/getStoreInputGroups/getStoreInputGroups';
import {CodeToInputGroupName} from '../../../../../../utilities/helper/codeToInputGroupName';

interface IProps {
  shouldOpen: boolean;
  setShouldOpen: Dispatch<SetStateAction<boolean>>;
  setFilterAdType: Dispatch<SetStateAction<string[]>>;
  filterAdType: string[];
  status?: Pick<IGetStoreInputGroupsParams, 'status'>['status'];
}

const FilterAdsByInputGroupBottomSheet = ({
  shouldOpen,
  setShouldOpen,
  setFilterAdType,
  filterAdType,
  status,
}: IProps) => {
  const [selectedAdTypes, setSelectedAdTypes] = useState<string[]>([]);

  const {data, isLoading} = useGetMyStoreInputGroups({
    enabled: shouldOpen,
    status: status,
    only_lendtech: false,
  });

  useEffect(() => {
    // reset the selected filters on change tab
    setSelectedAdTypes([]);
  }, [status]);

  const toggleAdType = (adType: string) => {
    setSelectedAdTypes(prev => {
      if (prev.includes(adType)) {
        // Remove if already selected
        return prev.filter(type => type !== adType);
      } else {
        // Add if not selected
        return [...prev, adType];
      }
    });
  };

  const handleSubmit = () => {
    setFilterAdType(selectedAdTypes);
    setShouldOpen(false);
  };

  return (
    <BottomSheet
      onDismiss={() => {
        setShouldOpen(false);
      }}
      open={shouldOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-4 p-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 cursor-pointer icon-nameClose-remove top-6 left-6"
          onClick={() => setShouldOpen(false)}
        />

        <div className="flex flex-col items-center justify-center w-full gap-2">
          <p className="font-medium text-md text-zinc-500">فیلترها</p>
        </div>

        <div className="flex flex-col justify-between w-full gap-4">
          {isLoading ? (
            <div className="flex justify-center py-8">
              <SpinnerLoading size={30} />
            </div>
          ) : (
            data && (
              <>
                <span className="font-medium text-zinc-500 text-md">
                  دسته بندی
                </span>
                <div className="flex flex-wrap items-center w-full gap-2">
                  {data.length > 0 ? (
                    data.map(item => {
                      const adType = CodeToInputGroupName[item.code];
                      const isSelected = selectedAdTypes.includes(adType);

                      return (
                        <CardInputGroup
                          key={item.guid}
                          isBoled={false}
                          isActive={isSelected}
                          title={item.title}
                          image={item.image}
                          guid={item.guid}
                          clickHandler={() => toggleAdType(adType)}
                        />
                      );
                    })
                  ) : (
                    <div>
                      <span>موردی برای نمایش یافت نشد</span>
                    </div>
                  )}
                </div>
              </>
            )
          )}

          <div className="flex items-center gap-2 pt-4">
            {filterAdType?.length > 0 && (
              <Button
                className="flex-1"
                variant="errorOutline"
                onClick={() => {
                  setFilterAdType([]);
                  setSelectedAdTypes([]);
                  setShouldOpen(false);
                }}
              >
                حذف فیلتر
              </Button>
            )}
            <Button
              className="flex-1"
              onClick={handleSubmit}
              disabled={selectedAdTypes.length === 0}
            >
              ثبت
            </Button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default FilterAdsByInputGroupBottomSheet;
